define('score_bootstrap/Models/Tile',["knockout"], function (ko) {
    "use strict";

    function Tile(item, tileName) {
        if (item && item.isIndexableItemBase !== true) {
            throw new TypeError("Tile constructor param 'item' must be IndexableItemBase");
        }

        this.id = String(item.id);
        this.element = ko.observable();
        this.tileHtml = item ? item.tiles[tileName] : "";
    }

    return Tile;
});
